'use strict';

var React = require('react');

class NewsUrgentListItem extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		var title = this.props.title;
		var target = this.props.target;

		return (
			<li>
				<a className="svtse_news-urgent-aside__link" href={target}>
					{title}
				</a>
			</li>
		);
	}
}

NewsUrgentListItem.propTypes = {
	title: React.PropTypes.string,
	target: React.PropTypes.string
};

module.exports = NewsUrgentListItem;



/** WEBPACK FOOTER **
 ** ./app/components/news/NewsUrgentListItem.jsx
 **/